<template>
    <div   v-on:keyup.esc="close" >
        <b-modal :active.sync="isComponentModalActive"
                 :full-screen.sync="isFullScreen"
                 has-modal-card  >

            <div class="modal-card ">
                <header class="modal-card-head"  >
                    <section class="modal-card-body  "  >
                        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
                        <HeaderDecorate :showLabNo=true :idlab="IDLABSelected.idlab" />
                    </section>
                </header>

                <section class="modal-card-body"  >
<TemplateLoadStatus :detail-loading="templateDetailLoading" :detail-error="templateDetailError" @retry-detail="retryTemplateDetail" />

                    <DetailUsedPartFromRequestDataEachLab
                            :IDLABSelected ="IDLABSelected"/>

                    <!--               Head     -->
                    <nav class="level is-mobile">
                        <div class="level-left">
                            <div class="level-item">
                                <p class="is-size-5"> Status </p>
                            </div>
                            <div class="level-item">
                                <p v-if="dataBACTSpecLN.status.id < 5 "  class="is-size-5 has-text-info"> &nbsp; {{ dataBACTSpecLN.status.name }}  </p>
                                <p v-if="dataBACTSpecLN.status.id >=5 && dataBACTSpecLN.status.id <=6"  class="is-size-5 has-text-success"> &nbsp; {{ dataBACTSpecLN.status.name }}  </p>
                                <p v-if="dataBACTSpecLN.status.id === 7 "  class="is-size-5 has-text-danger"> &nbsp; {{ dataBACTSpecLN.status.name }} </p>
                            </div>
                            <div class="level-item">
                                <b-icon icon="lock" type="is-danger"  v-if="dataBACTSpecLN.status.id >=5 "  ></b-icon>
                                <b-icon icon="lock-open" type="is-success"  v-if="dataBACTSpecLN.status.id < 5 "  ></b-icon>
                            </div>
                            <div class="level-item">
                                <p class="is-size-5"> Assigned for </p>
                            </div>
                            <div class="level-item">
                                <p class="is-size-5 has-text-black"> &nbsp; {{ dataBACTSpecLN.assigned_to_user.name }}</p>
                            </div>
                            <div class="level-item" v-if="userIsAdmin && dataBACTSpecLN.status.id !== 7 ">
                                <b-button size="is-medium"
                                          icon-left="minus-circle"  >
                                    Disable
                                </b-button>
                            </div>
                        </div>
                    </nav>



<!--------------------------------  Main   -->
                    <div class="box">
                        <nav class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <h1 class="title" style="color: #167df0">
                                        <b-icon  icon="file-document"  size="is-small"></b-icon>
                                        {{headerInfoPrepare}}
                                    </h1>
                                </div>


                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <p class="is-size-6 has-text-grey"> My Templates </p>
                                </div>
                                <div class="level-item">
                                    <b-select placeholder="Template" v-model="dataTemplateSelectedPrepare"
                                              :disabled="!(userRoleFind(3) &&dataBACTSpecLN.status.id <5)">
                                        <option
                                                v-for="dataTemplate in templateCatalogue"
                                                :value="dataTemplate.id"
                                                :key="dataTemplate.id">
                                            {{ dataTemplate.title }}
                                        </option>
                                    </b-select>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success"
                                              icon-right="plus"
                                              @click="addTemplate('editorDat_prepare')"
                                              :disabled="!(userRoleFind(3) &&dataBACTSpecLN.status.id <5)"/>
                                </div>
                            </div>
                        </nav>
                        <hr>
                        <vue-editor v-model="buffBACTDatPrepareDatModel "
                                    id="editorDat_prepare"
                                    :editor-toolbar="customToolbar"
                                    :disabled="!(userRoleFind(3) && dataBACTSpecLN.status.id <5 )"
                                    ref="editorDat_prepare"
                        />


                        <br>




                    </div>
<!--                BACT      -->
                    <div class="box" >

                        <nav class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <h1 class="title" style="color: #167df0">
                                        <b-icon  icon="file-document"  size="is-small"></b-icon>
                                        {{BacterialSelect}}
                                    </h1>
                                </div>


                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                 <b-button icon-left="plus" type="is-success" @click="addTemplateBact"
                                           :disabled="!((userRoleFind(4)  )&& dataBACTSpecLN.status.id <5 && dataBACTSpecLN.assigned_to_user.id === user_id)"
                                 >  Add </b-button>
                                </div>
                            </div>
                        </nav>
<!--                        :key="dataBact.idbact_uuid"-->

                        <div  v-for="(dataBact,index) in dataBACTSpecLN.data_bact"  :key="dataBact.idbact_uuid"  class="box" style="margin-top: 50px">

                            <Each_Bact
                                    :enable="dataBACTSpecLN.status.id <5"
                                    :data_bact="dataBact"
                                    :index ="index+1"
                                    @delete_idbact_uuid="delete_idbact_uuid"
                            />

                        </div>





                    </div>

<!-------------          findinds and contents       -->
                    <div class="box">
                        <nav class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <h1 class="title" style="color: #167df0">
                                        <b-icon  icon="file-document"  size="is-small"></b-icon>
                                        {{findingAndContent}}
                                    </h1>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <p class="is-size-6 has-text-grey"> My Templates </p>
                                </div>
                                <div class="level-item">

                                    <b-select placeholder="Template" v-model="dataTemplateSelectedCt"  :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataBACTSpecLN.status.id <5 && dataBACTSpecLN.assigned_to_user.id === user_id)">
                                        <option
                                                v-for="dataTemplate in templateCatalogue"
                                                :value="dataTemplate.id"
                                                :key="dataTemplate.id">
                                            {{ dataTemplate.title }}
                                        </option>
                                    </b-select>


                                </div>
                                <div class="level-item">
                                    <b-button type="is-success"
                                              icon-right="plus"
                                              @click="addTemplate('editorDat_ct')"
                                              :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataBACTSpecLN.status.id <5 && dataBACTSpecLN.assigned_to_user.id === user_id)"/>
                                </div>
                            </div>
                        </nav>
                        <hr>
                        <vue-editor v-model="buffBACTDatCtDatModel"
                                    id="editorDat_ct"
                                    :editor-toolbar="customToolbar"
                                    :disabled="!(userRoleFind(3) && dataBACTSpecLN.status.id <5 )"
                                    ref="editorDat_ct"
                        />
                    </div>

 <!--          images  ----------------------------->
                    <div class="box">
                        <nav class="level">
                            <h1 class="title" style="color: #167df0">
                                <b-icon  icon="camera-image"  size="is-small"></b-icon>
                                Add Images
                            </h1>
                        </nav>
                        <nav class="level">
                            <b-tooltip label="Attach Image"  position="is-right">
                                <b-button
                                        icon-right="paperclip"
                                        type="is-success"
                                        @click="addImageAttach"
                                        :disabled="!((userRoleFind(4)  )&&dataBACTSpecLN.status.id <5 && dataBACTSpecLN.assigned_to_user.id === user_id)"
                                        >Add Images</b-button>
                            </b-tooltip>
                        </nav>
                        <hr>
                        <ThumbnailImageList  :modeThumbnailImageList="modeThumbnailImageList" v-if="dataBACTSpecLN.img.dat.length>0"
                                             :dataPassThruImageList="dataPassThruImageList"
                                             @deleteImage="deleteImage" />
                        <hr  v-if="dataBACTSpecLN.img.dat.length>0">
                        <br>
                    </div>


 <!--         Dx Code  ------------------------->
                    <div class="box">
                        <nav class="level">
                            <h1 class="title" style="color: #167df0"> <b-icon
                                    icon="codepen"
                                    size="is-small">
                            </b-icon>  Classification of Diseases</h1>
                        </nav>
                        <nav class="level">
                            <b-tooltip label="Add More Disease Code"  position="is-right">
                                <b-button
                                        type="is-success"
                                        icon-right="plus"
                                        @click="addNewDiseaseCode"
                                        :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataBACTSpecLN.status.id <5 && dataBACTSpecLN.assigned_to_user.id === user_id)"
                                />

                            </b-tooltip>
                        </nav>
                        <br>

                        <b-table
                                :data="isEmpty ? [] : dataBACTSpecLN.diag_code.dat"
                                bordered
                                striped
                                narrowed
                                hoverable
                                focusable
                                mobile-cards>


                            <b-table-column   label="Chapter"  v-slot="props">
                                {{ props.row.level1Name }}
                            </b-table-column>
                            <b-table-column   label="Body System" v-slot="props">
                                {{ props.row.level2Name }}
                            </b-table-column>
                            <b-table-column   label="Organ/Tissue" v-slot="props">
                                {{ props.row.level3Name }}
                            </b-table-column>
                            <b-table-column   label="Character/Subcategories" v-slot="props">
                                {{ props.row.level4Name }}
                            </b-table-column>
                            <b-table-column   label="Extensions" v-slot="props">
                                {{ props.row.level5Name }}
                            </b-table-column>
                            <b-table-column   label="%" v-slot="props">
                                {{ props.row.labDiseasecodeAccurateName }}
                            </b-table-column>

                            <b-table-column   label="Unclassified Descriptions" v-slot="props" >
                                {{ props.row.unClassifiedCodes }}
                            </b-table-column>


                            <b-table-column   label="Remark" v-slot="props">
                                {{ props.row.comment }}
                            </b-table-column>





                            <b-table-column   label="#" v-slot="props">
                                <b-button type="is-danger" icon-right="delete" @click="deleteLabDiseasecodeRecWithLabID(props.row.ID)" :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataBACTSpecLN.status.id <5 && dataBACTSpecLN.assigned_to_user.id === user_id)" />
                            </b-table-column>



                            <template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Nothing here.</p>
                                    </div>
                                </section>
                            </template>
                        </b-table>


                    </div>
                </section>









                <footer class="modal-card-foot">
                    <div class="container" style=" width: 100vw; margin-left: 10px;">

                        <nav class="level" style="width:100vw;">
                            <div class="level-left">
                                <div class="level-item">
                                    <b-button type="is-danger"
                                              icon-left="close"  @click="close"   >
                                        Close
                                    </b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-warning" icon-left="cloud-upload"   v-if="userRoleFind(3)&&dataBACTSpecLN.status.id <5"   @click="updateData(3)"  > Save Prepare</b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"   v-if="(userRoleFind(4)  )&&dataBACTSpecLN.status.id <5 && dataBACTSpecLN.assigned_to_user.id === user_id "    @click="updateData(4)"  > Save Content to Draft</b-button>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"      v-if="(userRoleFind(4) ) &&dataBACTSpecLN.status.id <5 && dataBACTSpecLN.assigned_to_user.id === user_id "   @click="updateData(5)"  > Save Content to Publish Incomplete</b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"     v-if="(userRoleFind(4) ) &&dataBACTSpecLN.status.id <6 && dataBACTSpecLN.assigned_to_user.id === user_id "   @click="updateData(6)"  > Save Content to Publish Complete</b-button>
                                </div>

                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                            </div>
                        </nav>
                    </div>
                </footer>


            </div>


            <UploadFiles  v-if="isModalUploadFiles"
                          :idlab=null
                          :plus=false
                          @close="closeAddImageAttach"
                          @closeWithData="closeAddImageAttachWithData"/>

            <SelectDiseaseCode v-if="isModalSelectDiseaseCode"
                               @close="closeSelectDiseaseCode"
                               @closeWithChange="closeSelectDiseaseCode_WithChange" />


        </b-modal>

    </div>
</template>

<script>
import templateCatalogue from '@/mixins/templateCatalogue'
    import {mapActions, mapMutations, mapState} from "vuex";
    import userRoleFind from "../../mixins/methods/userRoleFind";
    import HeaderDecorate from "./DecorateComponents/HeaderDecorate";
    import globalconst from "../../mixins/globalconst";
    import Each_Bact from "./Bact/Each_Bact";
    import {  genUUID  , getBaseURLAvartar ,  getBaseURLforBackEnd , getConfigAxios , LOCATE_ENDPOINT_UPDATEEACH_KINDLAB }  from '@/utils.js'
    import UploadFiles from "../UtilsComponents/UploadFiles";
    import ThumbnailImageList from "../UtilsComponents/ThumbnailImageList";
    import SelectDiseaseCode from "./SelectDiseaseCode";
    import htmlToText from "html-to-text";
    import axios from "axios";
    import reloadMyJobsTray from "../../mixins/methods/reloadMyJobsTray";
    import DetailUsedPartFromRequestDataEachLab from "../UtilsComponents/DetailUsedPartFromRequestDataEachLab";


    export default {
        name: "EditDocLabBact",
        props:{
            isComponentModalActive : Boolean,
            IDLABSelected: null
        },
        mounted(){
            // window.vm = this
            // console.log('mount---->',JSON.stringify(this.dataBACTSpecLN))
            // this.tmpDataBact =  this.dataBACTSpecLN
        },
        components:{
            HeaderDecorate,
            Each_Bact,
            UploadFiles,
            ThumbnailImageList,
            SelectDiseaseCode,
            DetailUsedPartFromRequestDataEachLab
        },
        mixins:[templateCatalogue,userRoleFind,globalconst,reloadMyJobsTray],
        computed: {
            ...mapState({
                OPDSelected: state => state.opd_target.opd_selected,
                user_id: state => state.master_data.user_id,
                userIsAdmin: state => state.master_data.userIsAdmin,
                clientIP: state => state.master_data.clientIP,
                user_role: state => state.master_data.user_role,
                dataBACTSpecLN : state => state.bact.dataBACTSpecLN,
                buffBACTDatPrepareDat: state => state.bact.buffBACTDatPrepareDat,
                buffBACTDatCtDat: state => state.bact.buffBACTDatCtDat,
                tmplateBact: state => state.bact.tmplateBact,
                myTemplate: state => state.mytemplateTxt.myTemplate,
                access_token: state => state.master_data.access_token,
            }),

            
            // dataBACTSpecLNModel : {
            //                 get: function () {
            //                    return  this.dataBACTSpecLN 
            //                 },
            //                 set: function (newValue) {
            //                     this.setDataBACTSpecLN(newValue)
            //                 }
            // },
            dataPassThruImageList: function () {
                // [ { id: tmpID ,
                //     file : null,
                //     urlTempUploaded: tmpUrl,
                //     title : vm.dataAllContent.img.dat[i].title,
                //     fileNameUploaded:  vm.dataAllContent.img.dat[i].file ,
                //     fresh : false  } ]
                return this.dataBACTSpecLN.img.dat.map(dat => {
                    // console.log(dat)
                    return   { id: genUUID(5) ,
                        file : null,
                        urlTempUploaded:
                            dat.fresh ? `${getBaseURLAvartar()}/temp/${dat.file}` :   `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                        title : dat.title,
                        fileNameUploaded: dat.file,
                        fresh : false  }

                })
            },


            buffBACTDatPrepareDatModel :{
                get: function () {
                    return this.buffBACTDatPrepareDat
                },
                set: function (newValue) {
                    this.produceBuffBACTDatPrepareDat(newValue)
                }
            },

            buffBACTDatCtDatModel :{
                get: function () {
                    return this.buffBACTDatCtDat
                },
                set: function (newValue) {
                    this.produceBuffBACTDatCtDat(newValue)
                }
            },
            getTextFromCtHTML:function () {
                return  htmlToText.fromString(this.buffBACTDatCtDatModel || '', {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            },
            getTextFromPrepareHTML:function () {
                return  htmlToText.fromString(this.buffBACTDatPrepareDatModel || '', {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            },

        },
        methods:{
            ...mapMutations({
                setDataBACTSpecLN : 'bact/setDataBACTSpecLN',
            }),
            ...mapActions({
                fetchBACTOLDDat: 'bact/fetchBACTOLDDat',
                fetchMyJobsTray: 'myjobstray/fetchMyJobsTray',
                produceBuffBACTDatPrepareDat : 'bact/produceBuffBACTDatPrepareDat',
                produceBuffBACTDatCtDat : 'bact/produceBuffBACTDatCtDat',

            }),

            addTemplate(editorTarget) { return this.insertCachedTemplate(editorTarget) },


            closeSelectDiseaseCode_WithChange(dataToSave){
                this.dataBACTSpecLN.diag_code.dat.push(dataToSave)
            },
            closeSelectDiseaseCode(){
                this.isModalSelectDiseaseCode = false
            },
            addNewDiseaseCode(){
                this.isModalSelectDiseaseCode = true
            },


            deleteLabDiseasecodeRecWithLabID(id){
                const member = this.dataBACTSpecLN.diag_code.dat.find( member => member.ID === id)
                const memberIndex = this.dataBACTSpecLN.diag_code.dat.indexOf(member)

                this.dataBACTSpecLN.diag_code.dat.splice(memberIndex,1)

            },

            deleteImage(fileNameUploaded){
                const member = this.dataBACTSpecLN.img.dat.find(member => member.file === fileNameUploaded  )
                const memberIndex = this.dataBACTSpecLN.img.dat.indexOf(member)
                this.dataBACTSpecLN.img.dat.splice(memberIndex,1)
            },
            closeAddImageAttachWithData(dat){
                if(dat.file){

                    const tmp = {
                        "file":   dat.fileNameUploaded,
                        "title":  dat.title,
                        "fresh": true
                    }
                    this.dataBACTSpecLN.img.dat.push(tmp)
                }

                this.isModalUploadFiles = false
            },
            closeAddImageAttach(){
                this.isModalUploadFiles = false
            },
            addImageAttach(){
                this.isModalUploadFiles = true
            },
            delete_idbact_uuid(_idbact_uuid){
                // console.log(payload)
                const  tmp =  this.dataBACTSpecLN.data_bact.find(dat=>{
                    return dat.idbact_uuid == _idbact_uuid
                })


                const memberIndex =  this.dataBACTSpecLN.data_bact.indexOf(tmp)
                this.dataBACTSpecLN.data_bact.splice(memberIndex,1)

            },

            addTemplateBact(){
                // genUUID(12)
                // let  tmp = Object.assign( {} ,this.tmplateBact)
                var tmp = JSON.parse(JSON.stringify(this.tmplateBact))
                tmp.idbact_uuid = genUUID(12)
                for(var i=0;i<tmp.drugs.length;i++){
                     tmp.drugs[i].iddrug_uuid  = genUUID(9)
                }

                this.dataBACTSpecLN.data_bact.push( tmp )
            },
            loadOldDat(){
                this.isFullScreenSearching = true
                return this.fetchBACTOLDDat({ln: this.IDLABSelected.idlab, ip: this.clientIP})
                    .then(() => {
                        this.dataTemplateSelectedCt = null
                        this.dataTemplateSelectedPrepare = null
                    })
                    .catch(err => {
                        this.$buefy.dialog.alert({title: 'Error', message: 'โหลดผล BACT ไม่สำเร็จ กรุณาลองเปิดผลตรวจใหม่', type: 'is-danger'})
                        if (err.response && err.response.status === 401) this.$router.push('/login')
                    })
                    .finally(() => { this.isFullScreenSearching = false })
            },

            checkDataValid(){


                // check  Bacterial at least one
                if(this.dataBACTSpecLN.data_bact.length === 0 ){
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: `Bacterial Culture No information <b>  is empty  </b>`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return false
                }

                //  check Bacterial exist in every obj
                for(var i =0;i<this.dataBACTSpecLN.data_bact.length;i++){
                      if( this.dataBACTSpecLN.data_bact[i].idbact === null){
                          this.$buefy.dialog.alert({
                              title: 'Error',
                              message: `Bacterial Culture No. <b> ${i+1} </b> is empty <i>Bacterial name</i> `,
                              type: 'is-danger',
                              hasIcon: true,
                              icon: 'times-circle',
                              iconPack: 'fa',
                              ariaRole: 'alertdialog',
                              ariaModal: true
                          })
                          return false
                      }
                }


                //  check length iddrug in every obj


                for(var j =0;j<this.dataBACTSpecLN.data_bact.length;j++){
                    if( this.dataBACTSpecLN.data_bact[j].drugs.length === 0 && this.dataBACTSpecLN.data_bact[j].want_data_drugs){
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Bacterial Culture No. <b> ${j+1} </b>  No information for drug <b>(at least one data!)</b>  `,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        return false
                    }
                }



                //  check result in iddrug in every obj

                    for (var k = 0; k < this.dataBACTSpecLN.data_bact.length; k++) {

                       if( this.dataBACTSpecLN.data_bact[k].want_data_drugs){
                           for (var k1 = 0; k1 < this.dataBACTSpecLN.data_bact[k].drugs.length; k1++) {
                               if (this.dataBACTSpecLN.data_bact[k].drugs[k1].idresult === null ) {
                                   this.$buefy.dialog.alert({
                                       title: 'Error',
                                       message: `Bacterial Culture No. <b>${k + 1}</b>  for drug No. <b>${k1 + 1}</b>   is  <b>  empty </b>  `,
                                       type: 'is-danger',
                                       hasIcon: true,
                                       icon: 'times-circle',
                                       iconPack: 'fa',
                                       ariaRole: 'alertdialog',
                                       ariaModal: true
                                   })
                                   return false
                               }
                           }
                       }

                    }




                return true
            },

            updateData(idstatus){
                if (this.isSavingBACT || (this.IDLABSelected.kind || '').toUpperCase() !== 'BACTERIAL') return

                if(this.checkDataValid()) {
                    // console.log('ok')
                    // console.log(JSON.stringify(this.dataBACTSpecLN))


                    //  // update ICD10 Code
                    var arrIndex = []
                    var arrID_GRP_ICD10 = []
                    var arrID_ACCURATE = []
                    var arrUnclassifiedCode = []
                    var arrCommentTxt = []
                    //  clear null to empty string
                    for (var j = 0; j < this.dataBACTSpecLN.diag_code.dat.length; j++) {

                        if (this.dataBACTSpecLN.diag_code.dat[j].level5ID === null) {
                            this.dataBACTSpecLN.diag_code.dat[j].level5ID = ""
                        }
                        if (this.dataBACTSpecLN.diag_code.dat[j].level4ID === null) {
                            this.dataBACTSpecLN.diag_code.dat[j].level4ID = ""
                        }
                        if (this.dataBACTSpecLN.diag_code.dat[j].level3ID === null) {
                            this.dataBACTSpecLN.diag_code.dat[j].level3ID = ""
                        }
                        if (this.dataBACTSpecLN.diag_code.dat[j].level2ID === null) {
                            this.dataBACTSpecLN.diag_code.dat[j].level2ID = ""
                        }
                        if (this.dataBACTSpecLN.diag_code.dat[j].level1ID === null) {
                            this.dataBACTSpecLN.diag_code.dat[j].level1ID = ""
                        }


                    }

                    for (var i = 0; i < this.dataBACTSpecLN.diag_code.dat.length; i++) {

                        if (this.dataBACTSpecLN.diag_code.dat[i].level5ID !== "") {
                            arrID_GRP_ICD10.push(this.dataBACTSpecLN.diag_code.dat[i].level5ID)
                        } else if (this.dataBACTSpecLN.diag_code.dat[i].level4ID !== "") {
                            arrID_GRP_ICD10.push(this.dataBACTSpecLN.diag_code.dat[i].level4ID)
                        } else if (this.dataBACTSpecLN.diag_code.dat[i].level3ID !== "") {
                            arrID_GRP_ICD10.push(this.dataBACTSpecLN.diag_code.dat[i].level3ID)
                        } else if (this.dataBACTSpecLN.diag_code.dat[i].level2ID !== "") {
                            arrID_GRP_ICD10.push(this.dataBACTSpecLN.diag_code.dat[i].level2ID)
                        } else if (this.dataBACTSpecLN.diag_code.dat[i].level1ID !== "") {
                            arrID_GRP_ICD10.push(this.dataBACTSpecLN.diag_code.dat[i].level1ID)
                        } else {
                            arrID_GRP_ICD10.push(null)
                        }


                        arrIndex.push(this.dataBACTSpecLN.diag_code.dat[i].ID)
                        arrID_ACCURATE.push(this.dataBACTSpecLN.diag_code.dat[i].labDiseasecodeAccurateID)
                        arrUnclassifiedCode.push(this.dataBACTSpecLN.diag_code.dat[i].unClassifiedCodes)
                        arrCommentTxt.push(this.dataBACTSpecLN.diag_code.dat[i].comment)
                    }


                    //******************************************************************************************************
                    var arrImage = []
                    for (var k = 0; k < this.dataBACTSpecLN.img.dat.length; k++) {
                        arrImage.push({
                            "file": this.dataBACTSpecLN.img.dat[k].file,
                            "title": this.dataBACTSpecLN.img.dat[k].title,
                            "fresh": this.dataBACTSpecLN.img.dat[k].fresh
                        })
                    }


                    // console.log('ok')
                    //******************************************************************************************************
                    var arrData_bact = []  //  {"idbact_uuid": "","idbact": "", "name_bact": "",   "drugs": []}

                        //    { "id":"1","name":""Enrofloxacin,"result_dat":{ "mic_prefix":"" ,"mic_val": "", "result":"R/I/S","remark":"","sort_id": "","iddrug_uuid": ""}  }
                        for (var v = 0; v < this.dataBACTSpecLN.data_bact.length; v++) {

                            var tmpDrug = []
                            if (this.dataBACTSpecLN.data_bact[v].want_data_drugs){
                                for (var v1 = 0; v1 < this.dataBACTSpecLN.data_bact[v].drugs.length; v1++) {
                                    // IDDRUG IDRESULT  IDMIC_PREFIX  MIC_VAL  REMARK  SORT_ID IDDRUG_UUID
                                    tmpDrug.push({
                                        "iddrug": this.dataBACTSpecLN.data_bact[v].drugs[v1].iddrug,
                                        "idresult": this.dataBACTSpecLN.data_bact[v].drugs[v1].idresult,
                                        "idmic_prefix": this.dataBACTSpecLN.data_bact[v].drugs[v1].idmic_prefix,
                                        "mic_val": this.dataBACTSpecLN.data_bact[v].drugs[v1].mic_val,
                                        "remark": this.dataBACTSpecLN.data_bact[v].drugs[v1].remark,
                                        "sort_id": v1, //this.dataBACTSpecLN.data_bact[v].drugs[v1].sort_id,
                                        "iddrug_uuid": this.dataBACTSpecLN.data_bact[v].drugs[v1].iddrug_uuid
                                    })
                                }


                            }

                            arrData_bact.push({
                                // "idbact_uuid": `${v}${this.dataBACTSpecLN.data_bact[v].idbact_uuid}`,
                                "idbact_uuid": `${v}${genUUID(6)}`,
                                "idbact": this.dataBACTSpecLN.data_bact[v].idbact,
                                "bact_remark": this.dataBACTSpecLN.data_bact[v].bact_remark,
                                "id_lab_method" :  this.dataBACTSpecLN.data_bact[v].id_lab_method == "" || this.dataBACTSpecLN.data_bact[v].id_lab_method === null ? null :  this.dataBACTSpecLN.data_bact[v].id_lab_method,
                                "id_lab_method_result":  this.dataBACTSpecLN.data_bact[v].id_lab_method_result == "" || this.dataBACTSpecLN.data_bact[v].id_lab_method_result == null ? null : this.dataBACTSpecLN.data_bact[v].id_lab_method_result,
                                "remark_method":  this.dataBACTSpecLN.data_bact[v].remark_method == "" || this.dataBACTSpecLN.data_bact[v].remark_method == null  ? null : this.dataBACTSpecLN.data_bact[v].remark_method ,
                                "drugs": tmpDrug
                            })
                        }









                    const submittedPrepare = this.buffBACTDatPrepareDatModel
                    const submittedCt = this.buffBACTDatCtDatModel
                    const submittedRows = JSON.stringify(this.dataBACTSpecLN.data_bact)
                    const submittedOther = JSON.stringify([this.dataBACTSpecLN.diag_code, this.dataBACTSpecLN.img])
                    const encodeText = value => value == null ? null : Buffer.from(value, 'utf8').toString('base64')
                    const datTo = {
                        "ln": this.IDLABSelected.idlab,
                        "ip": this.clientIP,
                        "status": idstatus,
                        "data": {
                            "dat_prepare": encodeText(submittedPrepare),
                            "dat_prepare_txt": submittedPrepare == null ? null : encodeText(this.getTextFromPrepareHTML),
                            "dat_ct": encodeText(submittedCt),
                            "dat_ct_txt": submittedCt == null ? null : encodeText(this.getTextFromCtHTML),
                            "lab_diseasecode_labid": {
                                "arrindex": arrIndex,
                                "arrid_grp_icd10": arrID_GRP_ICD10,
                                "arrid_accurate": arrID_ACCURATE,
                                "arrunclassifiedcode": arrUnclassifiedCode,
                                "arrcommenttxt": arrCommentTxt
                            },
                            "lab_img_path": arrImage,
                            // "data_bact": [
                            //                   {"idbact_uuid": "","idbact": "", "name_bact": "", "drugs": []}    //  { "id":"1","name":""Enrofloxacin,"result_dat":{ "mic_prefix":"" ,"mic_val": "", "result":"R/I/S","remark":"","sort_id": "","iddrug_uuid": ""}  },
                            //              ],
                            "data_bact": arrData_bact

                        }
                    }


                    // console.log(JSON.stringify(datTo))
                    const vm = this
                    this.isFullScreenSearching = true
                    this.isSavingBACT = true
                    if ((this.IDLABSelected.kind).toUpperCase() === "BACTERIAL") {
                        axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                        axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_UPDATEEACH_KINDLAB.BACTERIAL}`, datTo, getConfigAxios())
                            .then(async res => {
                                const body = res.data || {}
                                try {
                                    const changed = vm.buffBACTDatPrepareDatModel !== submittedPrepare ||
                                        vm.buffBACTDatCtDatModel !== submittedCt ||
                                        JSON.stringify(vm.dataBACTSpecLN.data_bact) !== submittedRows ||
                                        JSON.stringify([vm.dataBACTSpecLN.diag_code, vm.dataBACTSpecLN.img]) !== submittedOther
                                    vm.dataBACTSpecLN.status.id = idstatus
                                    const saved = body.saved_text || {}
                                    if (Object.prototype.hasOwnProperty.call(saved, 'dat_prepare') && vm.buffBACTDatPrepareDatModel === submittedPrepare) vm.buffBACTDatPrepareDatModel = saved.dat_prepare
                                    if (Object.prototype.hasOwnProperty.call(saved, 'dat_ct') && vm.buffBACTDatCtDatModel === submittedCt) vm.buffBACTDatCtDatModel = saved.dat_ct
                                    if (JSON.stringify(vm.dataBACTSpecLN.data_bact) === submittedRows) {
                                        (body.saved_bacteria || []).forEach((row, i) => {
                                            const current = vm.dataBACTSpecLN.data_bact[i]
                                            if (!current) return
                                            current.bact_remark = row.bact_remark
                                            current.remark_method = row.remark_method
                                            if (current.want_data_drugs) row.drugs.forEach((drug, j) => { current.drugs[j].remark = drug.remark })
                                        })
                                    }
                                    const snapshot = () => JSON.stringify([vm.buffBACTDatPrepareDatModel, vm.buffBACTDatCtDatModel, vm.dataBACTSpecLN])
                                    const afterSync = snapshot()
                                    let skipped = changed
                                    const refreshes = [2,3,4,5].map(status => Promise.resolve().then(() => vm.fetchMyJobsTray({user_id: vm.user_id, status_id: status})))
                                    if (!changed) refreshes.push(Promise.resolve().then(() => vm.fetchBACTOLDDat({ln: datTo.ln, ip: datTo.ip,
                                        shouldApply: () => { const ok = snapshot() === afterSync; if (!ok) skipped = true; return ok }
                                    })))
                                    const failures = await Promise.all(refreshes.map(p => p.then(() => false, () => true)))
                                    const warning = skipped || failures.some(Boolean) || (body.warnings && body.warnings.length)
                                    vm.$buefy.toast.open({type: warning ? 'is-warning' : 'is-success', message: warning
                                        ? `บันทึกสำเร็จ แต่โหลดข้อมูลล่าสุดไม่ครบ มีข้อมูลแก้ไขเพิ่ม หรือมีคำเตือนหลังบันทึก (รหัสอ้างอิง: ${body.request_id || ''})`
                                        : 'Update data completely!'})
                                } catch (error) {
                                    vm.$buefy.toast.open({type: 'is-warning', message: `บันทึกสำเร็จ แต่แสดงผลล่าสุดไม่สำเร็จ กรุณาเปิดผลใหม่ก่อนบันทึกซ้ำ (รหัสอ้างอิง: ${body.request_id || ''})`})
                                }
                            })
                        .catch(err=>{
                            const result = (err.response && err.response.data) || {}
                            const messages = {
                                invalid_input: 'ข้อมูลที่ส่งไม่ถูกต้อง กรุณาตรวจสอบช่องที่ระบุ',
                                invalid_base64: 'รูปแบบข้อความไม่ถูกต้อง กรุณาเปิดผลตรวจใหม่',
                                invalid_master: 'รายการเชื้อ ยา ผล MIC หรือวิธีตรวจไม่ถูกต้อง กรุณาตรวจสอบช่องที่ระบุ',
                                invalid_result: 'ผลตรวจไม่ตรงกับตัวเลือกที่อนุญาต กรุณาเลือกใหม่',
                                text_too_long: 'ข้อความยาวเกินขนาดที่รองรับหลังแปลงอักขระ กรุณาตรวจสอบช่องที่ระบุ',
                                unsupported_characters: 'มีอักขระที่ฐานข้อมูลไม่รองรับ กรุณาตรวจสอบช่องที่ระบุ',
                                image_missing: 'ไม่พบไฟล์รูปชั่วคราว กรุณาอัปโหลดรูปใหม่',
                                image_conflict: 'ชื่อไฟล์รูปซ้ำกับไฟล์เดิมที่มีเนื้อหาต่างกัน กรุณาอัปโหลดใหม่',
                                status_conflict: 'ข้อมูลสถานะผลตรวจไม่สอดคล้อง กรุณาเปิดผลตรวจใหม่',
                                not_found: 'ไม่พบรายการตรวจ BACT นี้',
                                save_outcome_unknown: 'ยังยืนยันผลการบันทึกไม่ได้ กรุณาเปิดผลตรวจใหม่เพื่อตรวจสอบก่อนบันทึกซ้ำ',
                                save_failed: 'บันทึกไม่สำเร็จ กรุณาแจ้งรหัสอ้างอิงให้ผู้ดูแลตรวจสอบ'
                            }
                            const message = messages[result.code] || (err.response
                                ? 'บันทึกไม่สำเร็จ กรุณาตรวจสอบการเข้าสู่ระบบหรือแจ้งผู้ดูแล'
                                : 'ไม่ได้รับคำตอบจากระบบ กรุณาเปิดผลตรวจใหม่เพื่อตรวจสอบก่อนบันทึกซ้ำ')
                            // Buefy renders dialog messages as HTML; escape server fields.
                            const escapeHtml = value => String(value).replace(/[&<>"']/g, char => ({
                                '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
                            }[char]))
                            const characters = Array.isArray(result.unsupported_characters)
                                ? result.unsupported_characters.slice(0, 12)
                                    .map(item => `${item.character} (${item.codepoint})`).join(', ')
                                : ''
                            const characterHint = characters ? ` อักขระที่ไม่รองรับ: ${characters}` : ''
                            const field = result.field ? ` ช่อง: ${result.field}` : ''
                            const reference = result.request_id ? ` รหัสอ้างอิง: ${result.request_id}` : ''
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: escapeHtml(message + field + characterHint + reference),
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })


                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                            }
                        })
                            .finally(() => {
                                vm.isFullScreenSearching = false
                                vm.isSavingBACT = false
                            })
                    }


                }


            },
            close(){
                this.$emit('close')
            }
        },
        data(){
            return{
                isSavingBACT: false,
                // tmpDataBact : {},
                isFullScreenSearching : false,
                isFullScreen : true,
                customToolbar: [
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    // ["image", "code-block"],
                    [ "code-block"],
                    [{ 'color': [] }, { 'background': [] }],
                    ['link'],
                ],

                modeThumbnailImageList : "edit",
                isModalUploadFiles : false,
                isModalSelectDiseaseCode : false,
                isEmpty : false,

                dataTemplateSelectedCt : null,
                dataTemplateSelectedPrepare : null,
            }
        },
        watch:{
            isComponentModalActive :{
                immediate : true,
                handler: function (val) {
                    if(val){
                        this.loadOldDat()
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>
